import React from "react";
import PropTypes from "prop-types";
import {
    GSPSContainer,
    RequiredFormFieldIcon,
} from "Components/Common/GSPSLabeledInput.styles";
import MenuItem from "@mui/material/MenuItem";
import {
    GSPSFormControlStyled,
} from "Components/Common/GSPSLabelledSelectFieldWithIcon.styles";
import Select from "@mui/material/Select";
import CircleIcon from "@mui/icons-material/Circle";
import {FormControl} from "@mui/material";

export const GSPSLabelledSelectFieldWithIcon = ({
    labelName,
    inputID,
    selectableOptions,
    register,
    isDisabled = false,
    defaultValue = null,
    isRequired = true,
}) => {
    return (
        <GSPSContainer>
            <GSPSFormControlStyled>
                <label
                    htmlFor={inputID}
                    className="pb-0 label-sm fw-bold"
                >
                    <div style={{fontSize: "14px"}}>
                        {labelName}:
                        {isRequired &&
                            <RequiredFormFieldIcon className="--bs-danger">
                                *
                            </RequiredFormFieldIcon>
                        }
                    </div>
                </label>
                <FormControl focused={true} fullWidth={true}>
                    <Select
                        id={inputID}
                        name={inputID}
                        defaultValue={defaultValue !== null ? defaultValue : ""}
                        disabled={isDisabled}
                        onTouchStart={(e) => {
                            e.target.click();
                        }}
                        {...register(inputID)}
                    >
                        {selectableOptions.map((optionObject) => {
                            const colorVal = optionObject.color_code;
                            return (
                                <MenuItem
                                    value={optionObject.id}
                                    key={optionObject.id}
                                >
                                    {colorVal && <CircleIcon style={{color: colorVal, scale: "0.8"}} />}
                                    {optionObject.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </GSPSFormControlStyled>
        </GSPSContainer>
    );
};

GSPSLabelledSelectFieldWithIcon.propTypes = {
    labelName: PropTypes.string.isRequired,
    inputID: PropTypes.string.isRequired,
    selectableOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
        color_code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    register: PropTypes.func,
    isDisabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    isRequired: PropTypes.bool,
};
